/* eslint-disable react/button-has-type */
/* eslint-disable @getify/proper-ternary/nested */
import {
  LinearProgress,
  Step,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
  withStyles,
} from '@material-ui/core';
import { DefectTypesMap } from 'app/consumer-app/views/report-fault/report-fault-utils';
import { productImg } from 'app/core/api/product-assignment/api-product-assignment.types';
import {
  useQuoteSummery,
  useRepairerCase,
} from 'app/core/api/repairer/api-repairer';
import ProductPictureOrDefault from 'app/shared/components/app-image/ProductPictureOrDefault';
import Button from 'app/shared/components/button/Button';
import {
  DocumentSvg,
  SettingSvg,
  ExitSvg,
} from 'app/shared/components/icon/icon-lib';
import Body from 'app/shared/components/typography/body/Body';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import LoadingOverlay from 'app/shared/page-parts/LoadingOverlay';
import QuoteDetails from 'app/shared/pages/Chat/quote-details';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import styledFuncs from 'app/styles/styledFuncs';
import { useUrlParams } from 'app/tools/hooks/misc-hooks';
import { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { StatusTypeConsumerMap } from './status-type-util-consumer';

const TaskDetailContainer = styled.div`
  display: flex;
  margin: ${styledFuncs.pad(2)};
  text-align: center;
`;
const ProductPicture = styled(ProductPictureOrDefault)`
  width: 100px;
  padding: 0;
`;
const DetailsTitle = styled(Body)`
  font-weight: 600;
  + * {
    margin: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)} 0;
  }
`;
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundColor: '#6ABC35',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: '#6ABC35',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#EAEAEA',
    borderRadius: 1,
  },
})(StepConnector);
const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ ownerState }) => ({
  backgroundColor: '#FFFFFF',
  zIndex: 1,
  color: '#000000',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  svg: {
    path: { fill: '#000000' },
  },
  ...(ownerState.active && {
    border: '1px solid #6ABC35',
    svg: {
      path: { fill: '#6ABC35' },
    },
  }),
  ...(ownerState.completed && {
    border: '1px solid #6ABC35',
    svg: {
      path: { fill: '#6ABC35' },
    },
  }),
}));
export default function ProductDetails(): JSX.Element {
  const { id } = useUrlParams(['id']);
  const steps = ['Customer Drop Off', 'Under Repair', 'Pick Up'];
  const [activeStep, setActiveStep] = useState<number>(0);
  const [currentStatus, setCurrentStatus] = useState('');
  const [showDetailStatus, setShowDetailStatus] = useState(false);
  useSetPageTitle(`Product`);
  const { resource: repairCase, loading } = useRepairerCase(id);

  const { resource: quoteSummery } = useQuoteSummery(id);
  useEffect(() => {
    const step =
      repairCase?.caseStatus === 'repair_complete'
        ? 2
        : repairCase?.caseStatus === 'under_repair'
        ? 1
        : 0;
    setActiveStep(step);
    setCurrentStatus(repairCase?.caseStatus ?? 'accepted');
  }, [repairCase]);

  function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement } = {
      1: <DocumentSvg />,
      2: <SettingSvg />,
      3: <ExitSvg />,
    };
    const { icon } = props;
    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  }
  const BorderLinearProgress = withStyles(theme => ({
    root: {
      borderRadius: 5,
      width: 10,
      height: showDetailStatus
        ? `${
            repairCase?.caseTail
              ? repairCase?.caseTail?.length * 21
              : 0
          }px`
        : '60px',
      transform: 'rotate(180deg)',
    },
    colorPrimary: {
      backgroundColor:
        theme.palette.grey[
          theme.palette.type === 'light' ? 200 : 700
        ],
    },
    bar: {
      borderRadius: 5,
      transform: () =>
        `translateY(${
          currentStatus === 'customer_confirmed'
            ? '0'
            : showDetailStatus
            ? '5'
            : '40'
        }%) !important`,
      backgroundColor: theme.palette.primary.main,
    },
  }))(LinearProgress);
  return (
    <>
      <div style={{ display: 'block', margin: '20px' }}>
        <LoadingOverlay
          loadingComplete={!loading}
          translucent
          color="primary"
        />
        <ProductPicture
          productId={
            repairCase?.productDefectDetails.assignedProductDetails
              .productDetails?.id
          }
          src={productImg(
            repairCase?.productDefectDetails.assignedProductDetails
          )}
          height="100px"
          css={{ margin: '0 auto' }}
        />
        <TaskDetailContainer>
          <div style={{ flex: 1 }}>
            <DetailsTitle color="primary">Product name</DetailsTitle>
            <Body small>
              {
                repairCase?.productDefectDetails
                  .assignedProductDetails.productDetails?.name
              }
            </Body>
          </div>
          <div style={{ flex: 1 }}>
            <DetailsTitle color="primary">Issue type</DetailsTitle>
            <Body small>
              {DefectTypesMap.get(
                repairCase?.productDefectDetails?.title
              )}
              {/* {repairCase?.productDefectDetails.title} */}
            </Body>
          </div>
        </TaskDetailContainer>
        {repairCase?.paymentStatus !== 'HOLD' &&
          repairCase?.paymentStatus !== 'CAPTURE' && (
            <div>
              <DetailsTitle color="primary">
                User Description
              </DetailsTitle>
              <Body small>
                {repairCase?.productDefectDetails?.description}
              </Body>
              <Button
                css={{ margin: '0 auto', display: 'flex' }}
                to={`${SharedRoutePath.CHAT}/${id}`}
              >
                Go to chat
              </Button>
            </div>
          )}
        {(repairCase?.paymentStatus === 'HOLD' ||
          repairCase?.paymentStatus === 'CAPTURE') && (
          <div>
            <div
              style={{
                boxShadow: '0px 3px 10px rgba(0,0,0, 0.161)',
                borderRadius: '10px',
                position: 'relative',
              }}
            >
              <Stepper
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorlibConnector />}
              >
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel
                      StepIconComponent={(e: StepIconProps) =>
                        ColorlibStepIcon(e)
                      }
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div
                style={{
                  flexGrow: 1,
                  // height: 300,
                  gap: 10,
                  display: 'flex',
                  padding: 10,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    flex: 2,
                    textAlign: 'right',
                    fontSize: '10px',
                  }}
                >
                  {repairCase?.caseTail?.map((casetail, index) => (
                    <div
                      key={casetail.date}
                      style={
                        index === 0 ||
                        index === repairCase?.caseTail?.length - 1 ||
                        showDetailStatus === true
                          ? index !== 0 &&
                            index !== repairCase?.caseTail?.length - 1
                            ? {
                                color: '#A8A8A8',
                                marginBottom: '5px',
                              }
                            : {}
                          : { display: 'none' }
                      }
                    >
                      <div>
                        {StatusTypeConsumerMap.get(casetail.status)}
                      </div>
                      {repairCase?.caseTail?.length > 2 &&
                        index === 0 && <br />}
                    </div>
                  ))}
                </div>
                <BorderLinearProgress
                  variant="determinate"
                  value={currentStatus === 'collected' ? 0 : 10}
                  style={{ flex: 0.05 }}
                />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    flex: 2,
                    textAlign: 'left',
                    fontSize: '10px',
                  }}
                >
                  {repairCase?.caseTail?.map((casetail, index) => (
                    <div
                      key={casetail.date}
                      style={
                        index === 0 ||
                        index === repairCase?.caseTail?.length - 1 ||
                        showDetailStatus === true
                          ? index !== 0 &&
                            index !== repairCase?.caseTail?.length - 1
                            ? {
                                color: '#A8A8A8',
                                marginBottom: '5px',
                              }
                            : {}
                          : { display: 'none' }
                      }
                    >
                      <div>{casetail.date}</div>
                      {repairCase?.caseTail?.length > 2 &&
                        index === 0 && (
                          <button
                            onClick={() =>
                              setShowDetailStatus(!showDetailStatus)
                            }
                          >
                            {showDetailStatus
                              ? 'See less details'
                              : 'See more details'}
                          </button>
                        )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <h4 style={{ textAlign: 'center' }}>Payment Details</h4>
            <QuoteDetails quoteSummery={quoteSummery} />
          </div>
        )}
      </div>
    </>
  );
}
